export const __NAMESPACE__ = 'futuresai';
